import { useCallback } from 'react';
import { hideAll } from 'tippy.js';
import { Box, Button, ButtonGroup } from '@mui/material';
import { useInlineAsset } from '../context';

const DisplayControls = () => {
  const { inlineProps, inlineRecord, setView, removeAsset, isRelatedContent, refetch } =
    useInlineAsset();

  const isDisplayDisabled = isRelatedContent ? false : !inlineRecord?.uuid;
  const isCreateDisabled = isDisplayDisabled && !inlineProps.node.attrs?.placeholder;
  const handleClick = useCallback(
    async (view: string) => {
      // Reset bubble view in editor storage
      hideAll();
      inlineProps.editor.storage.bubbleMenu = { view: false };
      if (view === 'edit') {
        /**
         * Switching to edit view, grab latest data for the asset
         * only refetch if not related content
         */
        if (!isRelatedContent) {
          await refetch();
        }
      }
      setView(view as 'edit' | 'display' | 'properties' | null);
    },
    [inlineProps, setView, refetch, isRelatedContent],
  );

  const handleRemove = useCallback(() => {
    removeAsset();
    // Reset bubble view in editor storage
    hideAll();
    inlineProps.editor.storage.bubbleMenu = { view: false };
  }, [inlineProps, removeAsset]);

  return (
    <Box
      data-testid="inline-display-controls"
      sx={{
        position: 'absolute',
        top: '-0.85rem',
        zIndex: 1000,
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <ButtonGroup
        size="small"
        variant="contained"
        sx={(theme) => ({
          backgroundColor: theme.palette.background.default,
        })}
      >
        <Button
          data-testid="inline-asset-edit-button"
          aria-label="edit"
          onClick={() => handleClick('edit')}
          disabled={isCreateDisabled}
        >
          {inlineProps.node.attrs?.placeholder ? 'Create' : 'Edit'}
        </Button>
        <Button
          data-testid="inline-asset-properties-button"
          aria-label="display-properties"
          onClick={() => handleClick('properties')}
          disabled={isDisplayDisabled}
        >
          Display
        </Button>
        <Button
          data-testid="inline-asset-remove-button"
          onClick={handleRemove}
          aria-label="remove"
        >
          Remove
        </Button>
      </ButtonGroup>
    </Box>
  );
};

export default DisplayControls;
